import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EventsState } from '../../../../../../store/types';
import { getTermsConditions, createTermsConditions, updateTermsConditions, clearTermsConditions } from '../../../../../../store/actions/admin/terms-conditions';
import './terms-conditions.scss';
import WaitingIndicator from '../../../../../general-ui/waiting-indicator/waiting-indicator';
import { ColorKeys, TextOverrides } from '../../../../../../types/working-model';
import { cannedTermsConditions } from './cannedTermsConditions';
import EditableTextDraft from '../../../../../general-ui/editable-text/editable-text-draft';

interface Props {
	terms_id?: number | null;
	token: string | null;
	channel?: number;
	eventID?: string;
}

export default function TermsConditions({ terms_id, token, channel, eventID }: Props): JSX.Element {
	const {
		CreateEventReducer: {
			termsConditions,
		},
	} = useSelector((state: EventsState) => state);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(clearTermsConditions());
		if (terms_id) {
			dispatch(getTermsConditions(terms_id));
		}
	}, [terms_id, token, dispatch]);

	function handleTextChange(text: string) {
		if (termsConditions) {
			const updatedTerms = {
				...termsConditions,
				content: text,
			};
			dispatch(updateTermsConditions(updatedTerms, token!));
		} else {
			const newTerms = {
				eventID: eventID!,
				channel: channel!,
				content: text,
			};
			dispatch(createTermsConditions(newTerms, token!));
		}
	}

	function handleOverrideChange(overrides: TextOverrides) {
		if (!termsConditions) return;

		const updatedTerms = {
			...termsConditions,
			settings: {
				...termsConditions.settings,
				content: overrides,
			}
		};
		dispatch(updateTermsConditions(updatedTerms, token!));
	}

	const terms = terms_id === null ? cannedTermsConditions : termsConditions?.content;
	const textOverrides = termsConditions?.settings?.content?.color;

	return (
		<div className="editor-main-border">
			{ terms ?
				<div className="terms-conditions editor">
					<EditableTextDraft value={terms} onChange={handleTextChange} colorOverride={textOverrides} onOverrideChange={handleOverrideChange} defaultColor={ColorKeys.bodyTextColor} />
				</div>
				: <WaitingIndicator />}
		</div>
	);
}
